import { AxiosQUANTUM, AxiosMULEEX, AxiosBookings, quantumOrgId, quantumUserId } from "../apiConfig";

export const orgId = quantumOrgId;
export const userId = quantumUserId;

export const usersAndGroupsApiFactory = {
  $_getQuantumUsers(orgiD = null) {
    // let url = `/dashboard/get-all-user/${orgId()}`;
    let url = ``;
    if (orgiD) {
      url = `/user/${orgiD}?attributes=id,isRoot,fname,lname,email,isEmployee,createdAt,photo,isActive,updatedAt,deactivationReason&isActive=true`;
      return AxiosQUANTUM.get(url);
    } else
      url = `/user/${orgId()}?attributes=id,isRoot,fname,lname,email,isEmployee,createdAt,photo,isActive,updatedAt,deactivationReason&isActive=true`;

    return AxiosQUANTUM.get(url);
  },
   $_getMuleExUsers() {
      let url = "/users";
      return AxiosMULEEX.get(url);
    },
  $_getUsers(orgId) {
    // let url = `/dashboard/get-all-user/${orgId()}`;
    let url = ``;

      url = `/users/${orgId}?isActive=true`;
      return AxiosMULEEX.get(url);
  },
  $_getSingleUser(userId) {
    let url = `users/one/${userId}`;
    return AxiosMULEEX.get(url);
  },
  $_updateUser(payload, userId) {
    // let url = `/group/edit-groupuser/${payload.id}`;
    let url = `/users/${userId}`;
    return AxiosMULEEX.patch(url, payload);
  },
  $_createUser(payload) {
    let url = "/users/create";
    // payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_deactivateUser(userId, payload) {
    // let url = `/dashboard/deactivate-user/${userId}`;
    let url = `/users/deactivate/${userId}`;
    return AxiosMULEEX.patch(url, payload);
  },

  // $_getDeactivatedUsers() {
  //   // let url = `/dashboard/get-deactivateduser/${orgId()}`;
  //   let url = `/user/${orgId()}?attributes=id,isRoot,fname,lname,email,isEmployee,createdAt,photo,isActive,updatedAt,deactivationReason&isActive=false`;
  //   return AxiosQUANTUM.get(url);
  // },
  $_getDeactivatedUsers(orgId) {
    // let url = `/dashboard/get-deactivateduser/${orgId()}`;
    let url = `/users/${orgId}?isActive=false`;
    return AxiosMULEEX.get(url);
  },
  $_addUserToGroup(payload) {
    let url = `/org/groups/members`;
    return AxiosQUANTUM.post(url, payload);
  },
  $_deleteUser(userId) {
    let url = `/users/${userId}`;
    return AxiosMULEEX.delete(url);
  },
  $_reactivateUser(userId, payload) {
    // let url = `/dashboard/activate-user/${userId}`;
    let url = `/users/activate/${userId}`;
    return AxiosMULEEX.patch(url, payload);
  },
  $_reactivateMultipleUsers(payload) {
    let url = "/group/activateMultipleUser";
    return AxiosMULEEX.patch(url, payload);
  },
  $_deleteMultipleUsers(payload) {
    let url = "/group/deleteMultipleUser";
    return AxiosMULEEX.patch(url, payload);
  },
  $_getUserLocation(userId) {
    let url = `location-user/${userId}`;
    return AxiosMULEEX.get(url);
  },
  $_deleteUserLocation(payload) {
    let url = `location-user`;

    console.log({ data: payload })
    return AxiosMULEEX.delete(url, {data:payload});
  },
  $_getUserRoutes(userId) {
    let url = `route-users/${userId}`;
    return AxiosBookings.get(url);
  },
  $_deleteUserRoute(payload) {
    let url = `route-users`;

    console.log({data:payload})
    return AxiosBookings.delete(url, {data:payload});
  },
  // Groups
  $_getAllGroups() {
    // let url = `/dashboard/find-all-group/${orgId()}`;
    // let url = `/org/${orgId()}/groups/functional`;
    let url = `/org/${orgId()}/groups`;
    return AxiosQUANTUM.get(url);
  },
  $_getFunctionalGroups() {
    // let url = `/group/functional/${orgId()}`;
    let url = `/org/${orgId()}/groups?type=functional&status=active`;
    // let url = `/org/${orgId()}/groups/functional`;
    return AxiosQUANTUM.get(url);
  },
  $_getProjectGroups() {
    let url = `/org/${orgId()}/groups?type=project&status=active`;
    return AxiosQUANTUM.get(url);
  },
  $_getManagementGroups() {
    let url = `/org/${orgId()}/groups?type=management&status=active`;
    return AxiosQUANTUM.get(url);
  },
  $_getAllGroupsName() {
    // let url = `/dashboard/find-all-group-name/${orgId()}`;
    // return AxiosQUANTUM.get(url);
    return this.$_getFunctionalGroups()
  },
  $_createGroup(payload) {
    let url = "/org/groups";
    payload.orgId = orgId();
    payload.superAdminId = userId();
    return AxiosQUANTUM.post(url, payload);
  },
  $_updateGroup(payload) {
    let url = "/org/groups";
    payload.orgId = orgId();
    payload.superAdminId = userId();
    return AxiosQUANTUM.patch(url, payload);
  },
  $_deleteGroup(groupId) {
    // let url = `/dashboard/delete-group/${groupId}`;
    let url = `org/groups/${groupId}`;
    return AxiosQUANTUM.delete(url);
  },
  $_deactivateGroup(payload) {
    // let url = `/dashboard/deactivate-group/${groupId}`;
    let url = `/org/groups`;
    return AxiosQUANTUM.patch(url, payload);
  },
  $_getSingleGroupDetails(groupId) {
    let url = `/dashboard/view-group/${groupId}`;
    return AxiosQUANTUM.get(url);
  },
  $_getDeactivatedGroups() {
    // let url = `/dashboard/find-deactivated-group/${orgId()}`;
    let url = `/org/${orgId()}/groups?status=inactive`;
    return AxiosQUANTUM.get(url);
  },
  $_reactivateGroup(payload) {
    let url = `/org/groups`;
    return AxiosQUANTUM.patch(url, payload);
  },
  $_reactivateMultipleGroups(payload) {
    let url = "/group/activateMultiple";
    return AxiosQUANTUM.patch(url, payload);
  },
  $_deleteMultipleGroups(payload) {
    let url = "/group/deleteMultiple";
    return AxiosQUANTUM.patch(url, payload);
  },
  $_getActiveUser(orgId){
    let url =`/users/${orgId}?isActive=true`
    return AxiosMULEEX.get(url);
  }
};
